import { gray85 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var MuiTooltip = {
    styleOverrides: {
        tooltip: {
            boxShadow: '0 1px 2px #0000004D',
            backgroundColor: gray85,
            fontSize: rem(12),
            fontWeight: 'normal',
            paddingInline: rem(12),
        },
        tooltipPlacementLeft: {
            margin: "0 ".concat(rem(9)),
        },
        tooltipPlacementRight: {
            margin: "0 ".concat(rem(9)),
        },
        tooltipPlacementTop: {
            margin: '0 0',
        },
        tooltipPlacementBottom: {
            margin: "".concat(rem(9), " 0"),
        },
        arrow: {
            color: gray85,
        },
    },
};
